import { useCallback } from "react";
import type { User } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchIncidentUser = (
    userId?: string | null,
    vehicleId?: string | null,
    time?: Date,
): UseFetchActionReturn<User | undefined> => {
    const fetchIncidentUser: () => Promise<User | undefined> = useCallback(() => {
        if (userId) {
            return store.usersApi.usersReadUser({ userId });
        }
        if (vehicleId && time) {
            return store.usersApi.usersReadDriverByVehicleAndTime({ vehicleId, time });
        }
        return Promise.resolve(undefined);
    }, [userId, vehicleId, time]);

    return useFetchAction(fetchIncidentUser);
};
